import {Component, Input, OnInit} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-example-modal',
    templateUrl: './example-modal.component.html',
    styleUrls: ['./example-modal.component.less'],
    standalone: false
})
export class ExampleModalComponent implements OnInit {
  constructor(public modalRef: BsModalRef) { }

  ngOnInit() {
  }

}
